// Errors
export const ERROR_UNKNOWN_MESSAGE: string = 'ERROR.UNKNOWN';
export const ERROR_USER_NOT_FOUND_MESSAGE: string = 'ERROR.USER_NOT_FOUND';
export const ERROR_PASSWORD_MISMATCH_MESSAGE: string = 'ERROR.PASSWORD_MISMATCH';
export const ERROR_USERNAME_EXISTS_MESSAGE: string = 'ERROR.USERNAME_EXISTS';
export const ERROR_PSS_RESET_LIMIT_EXC_MESSAGE: string = 'ERROR.PSS_RESET_LIMIT_EXC';
export const ERROR_USER_NOT_AUTHORIZED_MESSAGE: string = 'ERROR.NOT_AUTHORIZED';
export const ERROR_ADMIN_ROLE_PERMISSION_MESSAGE: string = 'ERROR.ADMIN_ROLE_PERMISSION';
export const ERROR_STORE_BULK_CREATE_LIMIT_MESSAGE: string = 'ERROR.STORE_BULK_CREATE_LIMIT';
export const ERROR_STORE_INCONSISTENT_COMPANY_ID_MESSAGE: string = 'ERROR.STORE_INCONSISTENT_COMPANY_ID';
export const ERROR_BUYER_PAYMENT_SOURCE_REMOVE_MESSAGE: string = 'ERROR.BUYER_PAYMENT_SOURCE_REMOVE';
export const ERROR_LONG_NOT_ENABLED_MESSAGE: string = 'ERROR.LONG_NOT_ENABLED';
export const ERROR_COMPANY_DISABLED_MESSAGE: string = 'ERROR.COMPANY_DISABLED';
export const ERROR_COMPANY_PARTIALLY_ENABLED_MESSAGE: string = 'ERROR.COMPANY_PARTIALLY_ENABLED';
export const ERROR_EMPTY_LONG_RANGES_MESSAGE: string = 'ERROR.EMPTY_LONG_RANGES';
export const ERROR_CORRUPTED_FILE_MESSAGE: string = 'ERROR.CORRUPTED_FILE';
export const ERROR_COMPANY_CONTRACT_WITHOUT_SALES_NETWORK_MESSAGE: string =
  'ERROR.COMPANY_CONTRACT_WITHOUT_SALES_NETWORK';
export const ERROR_PRODUCT_CATEGORY_NAME_ALREADY_EXISTS_MESSAGE: string = 'ERROR.PRODUCT_CATEGORY_NAME_ALREADY_EXISTS';
export const ERROR_PRODUCT_SUBCATEGORY_NAME_ALREADY_EXISTS_MESSAGE: string =
  'ERROR.PRODUCT_SUBCATEGORY_NAME_ALREADY_EXISTS';
export const ERROR_PRODUCT_CATEGORY_DECIDO_CODE_ALREADY_EXISTS_MESSAGE: string =
  'ERROR.PRODUCT_CATEGORY_DECIDO_CODE_ALREADY_EXISTS';

// Success messages
export const GENERAL_COPIED_SUCCESS_MESSAGE: string = 'GENERAL.COPIED_LABEL';
export const AUTH_PSS_RESET_SUCCESS_TITLE: string = 'AUTH.PSS_RESET_SUCCESS_TITLE';
export const AUTH_PSS_RESET_SUCCESS_SUBTITLE: string = 'AUTH.PSS_RESET_SUCCESS_SUBTITLE';
export const REPORT_DOWNLOAD_SUCCESS_TITLE: string = 'REPORT.DOWNLOAD_SUCCESS_TITLE';
export const REPORT_DOWNLOAD_SUCCESS_MESSAGE: string = 'REPORT.DOWNLOAD_SUCCESS_MESSAGE';
export const SCRIPT_RUN_SUCCESS_TITLE: string = 'GENERAL.SCRIPT_START_TITLE';
export const SCRIPT_RUN_SUCCESS_MESSAGE: string = 'GENERAL.SCRIPT_START_MESSAGE';

// Navigation
export enum NavigationItemLabel {
  home = 'Home',
  companies = 'SHARED.TOOLBAR_COMPANIES_LABEL',
  sellers = 'SHARED.TOOLBAR_SELLERS_LABEL',
  stores = 'SHARED.TOOLBAR_STORES_LABEL',
  orders = 'SHARED.TOOLBAR_ORDERS_LABEL',
  buyers = 'SHARED.TOOLBAR_BUYERS_LABEL',
  steps = 'SHARED.TOOLBAR_STEPS_LABEL',
  report = 'SHARED.TOOLBAR_REPORT_LABEL',
  unpaid = 'SHARED.TOOLBAR_UNPAID_LABEL',
  pending_invitations = 'SHARED.TOOLBAR_PENDING_INVITATIONS_LABEL',
  scripts = 'Script',
  vop_request = 'SHARED.TOOLBAR_VOP_REQUEST_LABEL',
  settings = 'SHARED.TOOLBAR_SETTINGS_LABEL',
  product_category = 'SHARED.TOOLBAR_PRODUCT_CATEGORY_LABEL',
}

// Companies
export const PENDING_EVALUATION_LABEL: string = 'COMPANIES.SUMMARY_NO_CONTRACT_LABEL';
export const PENDING_SIGNATURE_LABEL: string = 'COMPANIES.SUMMARY_PENDING_SIGNATURE_LABEL';
export const PENDING_ACCEPTANCE_LABEL: string = 'COMPANIES.SUMMARY_PENDING_EVALUATION_LABEL';
export const ACCEPTED_LABEL: string = 'COMPANIES.ACCEPTED_LABEL';
export const DENIED_LABEL: string = 'COMPANIES.DENIED_LABEL';
export const ARCHIVED_LABEL: string = 'COMPANIES.ARCHIVED_LABEL';
export const PRODUCT_CATEGORY_CLOTHING_LABEL = 'COMPANIES.PRODUCT_CATEGORY_CLOTHING';
export const PRODUCT_CATEGORY_FURNITURE_LABEL = 'COMPANIES.PRODUCT_CATEGORY_FURNITURE';
export const PRODUCT_CATEGORY_MUSICAL_INSTRUMENTS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_MUSICAL_INSTRUMENTS';
export const PRODUCT_CATEGORY_SPORTING_GOODS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_SPORTING_GOODS';
export const PRODUCT_CATEGORY_COSMETICS_BEAUTY_LABEL = 'COMPANIES.PRODUCT_CATEGORY_COSMETICS_BEAUTY';
export const PRODUCT_CATEGORY_OPTICIANS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_OPTICIANS';
export const PRODUCT_CATEGORY_PROFESSIONAL_SERVICES_LABEL = 'COMPANIES.PRODUCT_CATEGORY_PROFESSIONAL_SERVICES';
export const PRODUCT_CATEGORY_DENTAL_CLINICS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_DENTAL_CLINICS';
export const PRODUCT_CATEGORY_MEDICAL_PRACTICES_LABEL = 'COMPANIES.PRODUCT_CATEGORY_MEDICAL_PRACTICES';
export const PRODUCT_CATEGORY_VETERINARIANS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_VETERINARIANS';
export const PRODUCT_CATEGORY_TV_TELEPHONY_AND_ELECTRONICS_LABEL =
  'COMPANIES.PRODUCT_CATEGORY_TV_TELEPHONY_AND_ELECTRONICS';
export const SALES_NETWORK_ID_LABEL = 'COMPANIES.SALES_NETWORK_ID_LABEL';
export const SETTINGS_PRODUCT_CATEGORIES_LABEL: string = 'SETTINGS.PRODUCT_CATEGORIES_LABEL';
export const SETTINGS_CLUSTER_LABEL: string = 'SETTINGS.CLUSTER_LABEL';

// new
export const PRODUCT_CATEGORY_LABEL = 'COMPANIES.PRODUCT_CATEGORY';
export const PRODUCT_CATEGORY_REAL_ESTATE_AGENCIES_LABEL = 'COMPANIES.PRODUCT_CATEGORY_REAL_ESTATE_AGENCIES';
export const PRODUCT_CATEGORY_HEARING_AIDS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_HEARING_AIDS';
export const PRODUCT_CATEGORY_HOME_AND_BATHROOM_FURNITURE_LABEL =
  'COMPANIES.PRODUCT_CATEGORY_HOME_AND_BATHROOM_FURNITURE';
export const PRODUCT_CATEGORY_INSURANCE_LABEL = 'COMPANIES.PRODUCT_CATEGORY_INSURANCE';
export const PRODUCT_CATEGORY_BICYCLES_LABEL = 'COMPANIES.PRODUCT_CATEGORY_BICYCLES';
export const PRODUCT_CATEGORY_BODYWORK_LABEL = 'COMPANIES.PRODUCT_CATEGORY_BODYWORK';
export const PRODUCT_CATEGORY_FURNITURE_ACCESSORIES_LABEL = 'COMPANIES.PRODUCT_CATEGORY_FURNITURE_ACCESSORIES';
export const PRODUCT_CATEGORY_DEALERS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_DEALERS';
export const PRODUCT_CATEGORY_DOOR_TO_DOOR_LABEL = 'COMPANIES.PRODUCT_CATEGORY_DOOR_TO_DOOR';
export const PRODUCT_CATEGORY_DIY_AND_HOME_IMPROVEMENT_LABEL = 'COMPANIES.PRODUCT_CATEGORY_DIY_AND_HOME_IMPROVEMENT';
export const PRODUCT_CATEGORY_PHYSIOTHERAPY_OSTEOPATHY_LABEL = 'COMPANIES.PRODUCT_CATEGORY_PHYSIOTHERAPY_OSTEOPATHY';
export const PRODUCT_CATEGORY_TRAINING_AND_COURSES_LABEL = 'COMPANIES.PRODUCT_CATEGORY_TRAINING_AND_COURSES';
export const PRODUCT_CATEGORY_TIRE_DEALERS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_TIRE_DEALERS';
export const PRODUCT_CATEGORY_HOME_ALARM_SYSTEMS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_HOME_ALARM_SYSTEMS';
export const PRODUCT_CATEGORY_CAR_ALARM_SYSTEMS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_CAR_ALARM_SYSTEMS';
export const PRODUCT_CATEGORY_CAR_MOTORCYCLE_REPAIR_SHOPS_LABEL =
  'COMPANIES.PRODUCT_CATEGORY_CAR_MOTORCYCLE_REPAIR_SHOPS';
export const PRODUCT_CATEGORY_GYMS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_GYMS';
export const PRODUCT_CATEGORY_BED_BASES_AND_MATTRESSES_LABEL = 'COMPANIES.PRODUCT_CATEGORY_BED_BASES_AND_MATTRESSES';
export const PRODUCT_CATEGORY_ENERGY_RENOVATION_LABEL = 'COMPANIES.PRODUCT_CATEGORY_ENERGY_RENOVATION';
export const PRODUCT_CATEGORY_DOORS_AND_WINDOWS_LABEL = 'COMPANIES.PRODUCT_CATEGORY_DOORS_AND_WINDOWS';
export const PRODUCT_CATEGORY_STOVES_AND_FIREPLACES_LABEL = 'COMPANIES.PRODUCT_CATEGORY_STOVES_AND_FIREPLACES';
export const PRODUCT_CATEGORY_LEISURE_LABEL = 'COMPANIES.PRODUCT_CATEGORY_LEISURE';
export const SALES_CHANNEL_STORE_LABEL = 'STORES.ONLY_PHYSICAL_STORES';
export const SALES_CHANNEL_ECOMMERCE_LABEL = 'STORES.ONLY_ECOMMERCE';
export const SALES_CHANNEL_STORE_AND_ECOMMERCE_LABEL = 'STORES.PHYSICAL_STORES_AND_ECOMMERCE';
export const ORIGIN_LOANS_LABEL = 'COMPANIES.LOANS_LABEL';
export const ORIGIN_MTP_LABEL = 'COMPANIES.MTP_LABEL';
export const ORIGIN_DIRECT_LABEL = 'COMPANIES.DIRECT_LABEL';
export const TAX_DEDUCTION_BM_LABEL = 'COMPANIES.TAX_DEDUCTION_BM_LABEL';
export const TAX_DEDUCTION_CT_LABEL = 'COMPANIES.TAX_DEDUCTION_CT_LABEL';
export const TAX_DEDUCTION_TC_LABEL = 'COMPANIES.TAX_DEDUCTION_TC_LABEL';
export const TAX_DEDUCTION_IS_LABEL = 'COMPANIES.TAX_DEDUCTION_IS_LABEL';
export const TAX_DEDUCTION_RE_LABEL = 'COMPANIES.TAX_DEDUCTION_RE_LABEL';
export const TAX_DEDUCTION_RS_LABEL = 'COMPANIES.TAX_DEDUCTION_RS_LABEL';
export const AGREEMENT_LABEL = 'GENERAL.AGREEMENT_LABEL';
export const ERROR_COMPANY_BNPL_LONG_DISABLED_MESSAGE = 'COMPANIES.COMPANY_BNPL_LONG_DISABLED_MESSAGE';
export const ERROR_STORE_BNPL_MIN_AMOUNT_OUT_OF_COMPANY_RANGE_MESSAGE =
  'STORES.STORE_BNPL_MIN_AMOUNT_OUT_OF_COMPANY_RANGE_MESSAGE';
export const ERROR_STORE_BNPL_MAX_AMOUNT_OUT_OF_COMPANY_RANGE_MESSAGE =
  'STORES.STORE_BNPL_MAX_AMOUNT_OUT_OF_COMPANY_RANGE_MESSAGE';

// Stores
export const ON_SESSION_SALES_LABEL: string = 'STORES.ON_SESSION_SALES_LABEL';
export const OFF_SESSION_SALES_LABEL: string = 'STORES.OFF_SESSION_SALES_LABEL';
export const IN_STORE_SALES_LABEL: string = 'STORES.IN_STORE_SALES_LABEL';
export const WEB_SALES_LABEL: string = 'STORES.WEB_SALES_LABEL';
export const WEB_OFF_SESSION_SALES_LABEL = 'GENERAL.WEB_OFF_SESSION_SALES_LABEL';
export const ENABLED_LABEL: string = 'GENERAL.ENABLED_LABEL';
export const PARTIALLY_ENABLED_LABEL: string = 'GENERAL.PARTIALLY_ENABLED_LABEL';
export const DISABLED_LABEL: string = 'GENERAL.DISABLED_LABEL';
export const STORE_NAME_LABEL: string = 'GENERAL.STORE_LABEL';

// Filters
export const COMPANY_ID_LABEL: string = 'ID';
export const COMPANY_LABEL: string = 'Azienda';
export const BUSINESS_NAME_LABEL: string = 'STORES.BUSINESS_NAME_LABEL';
export const VAT_LABEL: string = 'STORES.VAT_LABEL';
export const STATUS_LABEL: string = 'ORDERS.STATUS_COLUMN_LABEL';
export const CMS_LABEL: string = 'STORES.CMS_LABEL';
export const STORE_ID_LABEL: string = 'ID';
export const NAME_LABEL: string = 'GENERAL.NAME_LABEL';
export const SELLER_ID_LABEL: string = 'GENERAL.SELLER_ID_LABEL';
export const PHONE_VALUE_LABEL: string = 'GENERAL.PHONE_VALUE_LABEL';
export const OWNER_LINK_LABEL: string = 'GENERAL.OWNER_LINK_LABEL';
export const EMAIL_LABEL: string = 'GENERAL.EMAIL_LABEL';
export const IS_CONFIRMED_LABEL: string = 'SELLERS.CONFIRMED_LABEL';
export const CONFIRMED_GREEN_LABEL: string = 'SELLERS.CONFIRMED_GREEN_LABEL';
export const CONFIRMED_ORANGE_LABEL: string = 'SELLERS.CONFIRMED_ORANGE_LABEL';
export const CONFIRMED_RED_LABEL: string = 'SELLERS.CONFIRMED_RED_LABEL';
export const BUYER_ID_LABEL: string = 'ID';
export const MERCHANT_REFUND_LABEL: string = 'ORDERS.MERCHANT_REFUND_LABEL';
export const LAST_OPERATION_LABEL: string = 'ORDERS.LAST_OPERATION_LABEL';
export const FILTER_LAST_OPERATION_FROM_LABEL: string = 'ORDERS.FILTER_LAST_OPERATION_FROM_LABEL';
export const FILTER_LAST_OPERATION_TO_LABEL: string = 'ORDERS.FILTER_LAST_OPERATION_TO_LABEL';
export const ONBOARDING_COMPLETED_FROM_LABEL: string = 'BUYERS.FILTER_ONBOARDING_COMPLETED_FROM_LABEL';
export const ONBOARDING_COMPLETED_TO_LABEL: string = 'BUYERS.FILTER_ONBOARDING_COMPLETED_TO_LABEL';

// Forms
export const FORM_STATUS_FIELD_LABEL: string = 'ORDERS.STATUS_COLUMN_LABEL';
export const FORM_CHANNEL_FIELD_LABEL: string = 'ORDERS.CHANNEL_COLUMN_LABEL';
export const FORM_ORIGIN_FIELD_LABEL: string = 'ORDERS.ORIGIN_COLUMN_LABEL';
export const FORM_CREATED_FROM_FIELD_LABEL: string = 'ORDERS.FILTER_CREATED_FROM_LABEL';
export const FORM_CREATED_TO_FIELD_LABEL: string = 'ORDERS.FILTER_CREATED_TO_LABEL';
export const FORM_COMPLETED_FROM_FIELD_LABEL: string = 'ORDERS.FILTER_COMPLETED_FROM_LABEL';
export const FORM_COMPLETED_TO_FIELD_LABEL: string = 'ORDERS.FILTER_COMPLETED_TO_LABEL';
export const FORM_ORDER_ID_FIELD_LABEL: string = 'ORDERS.ORDER_ID_COLUMN_LABEL';
export const FORM_COMPANY_ID_FIELD_LABEL: string = 'ORDERS.COMPANY_ID_COLUMN_LABEL';
export const FORM_DUE_DATE_FROM_FIELD_LABEL: string = 'STEPS.FILTER_DUE_DATE_FROM_LABEL';
export const FORM_DUE_DATE_TO_FIELD_LABEL: string = 'STEPS.FILTER_DUE_DATE_TO_LABEL';
export const FORM_STEP_ID_FIELD_LABEL: string = 'STEPS.ID_COLUMN_LABEL';

// Orders
export const ORDER_STATUS_COMPLETED_LABEL: string = 'ORDERS.COMPLETED_LABEL';
export const ORDER_STATUS_RUNNING_LABEL: string = 'ORDERS.RUNNING_LABEL';
export const ORDER_STATUS_CANCELED_LABEL: string = 'ORDERS.CANCELED_LABEL';
export const ORDER_STATUS_REFUNDED_LABEL: string = 'ORDERS.REFUNDED_LABEL';
export const ORDER_STATUS_PENDING_LABEL: string = 'ORDERS.PENDING_LABEL';
export const ORDER_STATUS_STORE_REVIEW_LABEL: string = 'ORDERS.STORE_REVIEW_LABEL';
export const ORDER_STATUS_ARCHIVED_LABEL: string = 'ORDERS.ARCHIVED_LABEL';
export const ORDER_STEP_COMPLETED_LABEL: string = 'STEPS.COMPLETED_LABEL';
export const ORDER_STEP_REFUNDED_LABEL: string = 'STEPS.REFUNDED_LABEL';
export const ORDER_STEP_CANCELED_LABEL: string = 'STEPS.CANCELED_LABEL';
export const DEL_POS_LABEL = 'ORDERS.DEL_POS_LABEL';
export const DEL_NEG_LABEL = 'ORDERS.DEL_NEG_LABEL';
export const BD1_LABEL = 'ORDERS.BD1';
export const BD2_LABEL = 'ORDERS.BD2';
export const BD5_LABEL = 'ORDERS.BD5';
export const LIQUIDATION_LABEL = 'ORDERS.LIQUIDATION_LABEL';
export const QINETIC_ID_LABEL = 'ORDERS.QINETIC_ID_LABEL';
export const APPROVED_LABEL = 'ORDERS.APPROVED_LABEL';
export const QINETIC_BUG_LABEL = 'ORDERS.QINETIC_BUG_LABEL';
export const HAS_QINETIC_ID_LABEL = 'ORDERS.HAS_QINETIC_ID_LABEL';
export const EXT_ORDER_ID_LABEL = 'ORDERS.EXT_ORDER_ID_LABEL';
export const UNPAID_DAYS_LABEL = 'UNPAID.DAYS_UNPAID_LABEL';
export const UNPAID_LABEL = 'UNPAID.UNPAID_LABEL';
export const TAX_DEDUCTION_LABEL = 'ORDERS.TAX_DEDUCTION_LABEL';
export const TAX_DEDUCTION_TYPE_LABEL = 'COMPANIES.TAX_DEDUCTION_TYPE_LABEL';
export const BUYER_COLUMN_LABEL = 'ORDERS.BUYER_COLUMN_LABEL';

//Buyers
export const BUYER_IN_STORE_SALES_LABEL: string = 'BUYERS.IN_STORE_ORIGIN_LABEL';
export const BUYER_IN_ORDER_SALES_LABEL: string = 'BUYERS.IN_ORDER_ORIGIN_LABEL';
export const BUYER_IN_WEBSITE_SALES_LABEL: string = 'BUYERS.IN_WEBSITE_ORIGIN_LABEL';

// Invitations
export const COMPANY_ID_FIELD_LABEL: string = 'PENDING_INVITATIONS.COMPANY_ID_LABEL';
export const RECIPIENT_EMAIL_FIELD_LABEL: string = 'PENDING_INVITATIONS.RECIPIENT_EMAIL_LABEL';
export const COMPANY_BUSINESS_NAME_FIELD_LABEL: string = 'PENDING_INVITATIONS.COMPANY_BUSINESS_NAME_LABEL';
export const STORES_FIELD_LABEL: string = 'PENDING_INVITATIONS.STORES_LABEL';
export const SENDER_EMAIL_FIELD_LABEL: string = 'PENDING_INVITATIONS.SENDER_EMAIL_LABEL';
export const RECIPIENT_ROLE_FIELD_LABEL: string = 'PENDING_INVITATIONS.RECIPIENT_ROLE_LABEL';

export const VBAN_STATUS_SUCCEEDED_LABEL: string = 'VBAN.SUCCEEDED_LABEL';
export const VBAN_STATUS_PENDING_LABEL: string = 'VBAN.PENDING_LABEL';
export const VBAN_STATUS_PARTIALLY_FUNDED_LABEL: string = 'VBAN.PARTIALLY_FUNDED_LABEL';

export const UNPAID_STATUS_CANCELED_LABEL: string = 'ORDERS.UNPAID_CANCELED_LABEL';
export const UNPAID_STATUS_RECOVERED_LABEL: string = 'ORDERS.UNPAID_RECOVERED_LABEL';
export const UNPAID_STATUS_EXPIRED_LABEL: string = 'ORDERS.UNPAID_EXPIRED_LABEL';
export const UNPAID_STATUS_PENDING_LABEL: string = 'ORDERS.UNPAID_PENDING_LABEL';

export const WOOCOMMERCE_LABEL: string = 'GENERAL.WOOCOMMERCE_LABEL';
export const PRESTASHOP_LABEL: string = 'GENERAL.PRESTASHOP_LABEL';
export const SHOPIFY_LABEL: string = 'GENERAL.SHOPIFY_LABEL';
export const MAGENTO_LABEL: string = 'GENERAL.MAGENTO_LABEL';
export const OTHER_LABEL: string = 'GENERAL.OTHER_LABEL';

// Details navbar
export const ORDER_DETAILS_GENERAL_TAB_LABEL = 'ORDER_DETAILS.GENERAL_TAB_LABEL';
export const ORDER_DETAILS_INSTALLMENTS_TAB_LABEL = 'ORDER_DETAILS.INSTALLMENTS_TAB_LABEL';
export const ORDER_DETAILS_DECIDO_TAB_LABEL = 'ORDER_DETAILS.DECIDO_TAB_LABEL';
export const ORDER_DETAILS_QINETIC_TAB_LABEL = 'ORDER_DETAILS.QINETIC_TAB_LABEL';
export const ORDER_DETAILS_EVENTS_TAB_LABEL = 'ORDER_DETAILS.EVENTS_TAB_LABEL';
export const STORE_DETAILS_GENERAL_TAB_LABEL = 'STORE_DETAILS.GENERAL_TAB_LABEL';
export const STORE_DETAILS_EVENTS_TAB_LABEL = 'STORE_DETAILS.EVENTS_TAB_LABEL';
export const STORE_DETAILS_TEAM_TAB_LABEL = 'STORE_DETAILS.TEAM_TAB_LABEL';
export const SELLER_DETAILS_GENERAL_TAB_LABEL = 'SELLER_DETAILS.GENERAL_TAB_LABEL';
export const SELLER_DETAILS_EVENTS_TAB_LABEL = 'SELLER_DETAILS.EVENTS_TAB_LABEL';
export const BUYER_DETAILS_GENERAL_TAB_LABEL = 'BUYER_DETAILS.GENERAL_TAB_LABEL';
export const BUYER_DETAILS_ORDER_TAB_LABEL = 'BUYER_DETAILS.ORDER_TAB_LABEL';
export const BUYER_DETAILS_EVENTS_TAB_LABEL = 'BUYER_DETAILS.EVENTS_TAB_LABEL';
export const COMPANY_DETAILS_GENERAL_TAB_LABEL = 'COMPANY_DETAILS.GENERAL_TAB_LABEL';
export const COMPANY_DETAILS_TEAM_TAB_LABEL = 'COMPANY_DETAILS.TEAM_TAB_LABEL';
export const COMPANY_DETAILS_STORE_TAB_LABEL = 'COMPANY_DETAILS.STORE_TAB_LABEL';
export const COMPANY_DETAILS_EVENTS_TAB_LABEL = 'COMPANY_DETAILS.EVENTS_TAB_LABEL';
export const COMPANY_PENDING_INVITATION_LABEL: string = 'PENDING_INVITATIONS.TITLE';
export const COMPANY_DETAILS_UNPAID_TAB_LABEL = 'SHARED.TOOLBAR_UNPAID_LABEL';

export const CREATED_AT_LABEL = 'ORDERS.CREATED_AT_LABEL';
export const BUYER_STRIPE_PAYMENT_SOURCE_LABEL = 'ORDERS.BUYER_STRIPE_PAYMENT_SOURCE_LABEL';
export const PRE_AUTHORIZATION_AT_LABEL = 'ORDERS.PRE_AUTHORIZATION_AT_LABEL';
export const EXPERIAN_VERIFICATION_LABEL = 'ORDERS.EXPERIAN_VERIFICATION_LABEL';
export const FEA_CONTRACT_ID_LABEL = 'ORDERS.FEA_CONTRACT_ID_LABEL';
export const CONTRACT_ID_LABEL = 'ORDERS.CONTRACT_ID_LABEL';
export const COMPLETED_AT_LABEL = 'ORDERS.COMPLETED_AT_LABEL';
export const CANCELED_AT_LABEL = 'ORDERS.CANCELED_AT_LABEL';
export const REFUNDED_AT_LABEL = 'ORDERS.REFUNDED_AT_LABEL';
export const ARCHIVED_AT_LABEL = 'ORDERS.ARCHIVED_AT_LABEL';
export const RUNNING_AT_LABEL = 'ORDERS.RUNNING_AT_LABEL';
export const PENDING_AT_LABEL = 'ORDERS.PENDING_AT_LABEL';
export const READY_FOR_LIQUIDATION_AT_LABEL = 'ORDERS.READY_FOR_LIQUIDATION_AT_LABEL';

//Vop Request
export const VOP_REQUEST_PENDING_LABEL: string = 'VOP_REQUEST.PENDING_LABEL';
export const VOP_REQUEST_FAILED_LABEL: string = 'VOP_REQUEST.FAILED_LABEL';
export const VOP_REQUEST_SUCCEEDED_LABEL: string = 'VOP_REQUEST.SUCCEEDED_LABEL';
export const VOP_REQUEST_ID_LABEL: string = 'VOP_REQUEST.ID_COLUMN_LABEL';
export const VOP_REQUEST_STATUS_LABEL: string = 'VOP_REQUEST.STATUS_LABEL';
export const VOP_REQUEST_RESULT_LABEL: string = 'VOP_REQUEST.RESULT';
export const VOP_REQUEST_BENEFICIARY_FIRSTNAME_LABEL_LABEL: string = 'VOP_REQUEST.BENEFICIARY_FIRSTNAME_LABEL';
export const VOP_REQUEST_BENEFICIARY_LASTNAME_LABEL: string = 'VOP_REQUEST.BENEFICIARY_LASTNAME_LABEL';
export const VOP_REQUEST_BENEFICIARY_TAX_CODE_LABEL: string = 'VOP_REQUEST.BENEFICIARY_TAX_CODE_LABEL';
export const VOP_REQUEST_BENEFICIARY_IBAN_LABEL: string = 'VOP_REQUEST.BENEFICIARY_IBAN';
export const VOP_REQUEST_ORDER_ID_LABEL: string = 'VOP_REQUEST.ORDER_ID';
export const VOP_REQUEST_BUYER_ID_LABEL: string = 'VOP_REQUEST.BUYER_ID';
export const VOP_REQUEST_FL_CALL_LABEL: string = 'VOP_REQUEST.FL_CALL_LABEL';
export const VOP_REQUEST_LF_CALL_LABEL: string = 'VOP_REQUEST.LF_CALL_LABEL';
export const VOP_REQUEST_TAX_CODE_CALL_LABEL: string = 'VOP_REQUEST.TAX_CODE_CALL_LABEL';
export const VOP_REQUEST_MTCH_LABEL: string = 'VOP_REQUEST.MTCH_LABEL';
export const VOP_REQUEST_NMTC_LABEL: string = 'VOP_REQUEST.NMTC_LABEL';
export const VOP_REQUEST_CMTC_LABEL: string = 'VOP_REQUEST.CMTC_LABEL';
